/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeViewcollectionsData } from './moe-viewcollections.data';
import { IMoeViewcollectionsProps } from './moe-viewcollections.props.autogenerated';

import {
    INodeProps,
    NodeTag,
    ISingleSlideCarouselProps,
    SingleSlideCarousel,
    IComponentNodeProps,
    ITelemetryContent,
    getTelemetryObject
} from '@msdyn365-commerce-modules/utilities';

export interface IMoeViewcollectionsViewProps extends IMoeViewcollectionsProps<IMoeViewcollectionsData> {
    ProductContainer: INodeProps;
    singleSlideCarouselComponentProps: INodeProps;
}

/**
 *
 * MoeViewcollections component
 * @extends {React.PureComponent<IMoeViewcollectionsProps<IMoeViewcollectionsData>>}
 */
class MoeViewcollections extends React.PureComponent<IMoeViewcollectionsProps<IMoeViewcollectionsData>> {
    private readonly _telemetryContent: ITelemetryContent = getTelemetryObject(
        this.props.context.request.telemetryPageName!,
        this.props.friendlyName,
        this.props.telemetry
    );

    constructor(props: IMoeViewcollectionsProps<IMoeViewcollectionsData>) {
        super(props);
    }

    public render(): JSX.Element | null {
        const { resources } = this.props;

        const propsCarousel: IComponentNodeProps<ISingleSlideCarouselProps> = {
            tag: SingleSlideCarousel,
            className: this.props.config.className ?? '',
            flipperPrevLabel: resources.flipperPrevious,
            flipperNextLabel: resources.flipperNext,
            parentId: this.props.id,
            telemetryContent: this._telemetryContent,
            vertical: false
        };

        const viewProps: IMoeViewcollectionsViewProps = {
            ...this.props,
            ProductContainer: {
                tag: 'li' as NodeTag,
                className: 'ms-product-collection__item',
                role: 'listitem'
            },
            singleSlideCarouselComponentProps: propsCarousel
        };

        return this.props.renderView(viewProps);
    }
}

export default MoeViewcollections;
